var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Spinner'),_c('ComposeModal'),_c('Header'),_c('div',{attrs:{"id":"trs-wrapper"}},[_c('router-view'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }